export default [
    {
        "year": 1985,
        "question": "屈肘时主要的收缩肌肉是（）",
        "A": "肱三头肌",
        "B": "肱二头肌",
        "C": "三角肌",
        "D": "胸大肌",
        "answer": "B"
    },
    {
        "year": 1986,
        "question": "植物的向地性说明了生物体的（）",
        "A": "适应性",
        "B": "抗旱性",
        "C": "应激性",
        "D": "遗传性",
        "answer": "C"
    },
    {
        "year": 1987,
        "question": "下列植物中，以匍匐枝进行繁殖的是（）",
        "A": "草莓",
        "B": "莲",
        "C": "蓟",
        "D": "竹",
        "answer": "A"
    },
    {
        "year": 1988,
        "question": "水稻叶肉细胞中的DNA存在于（）",
        "A": "细胞核、叶绿体和高尔基体",
        "B": "内质网、线粒体和细胞核.",
        "C": "线粒体、叶绿体和细胞核",
        "D": "细胞核、核糖体和线粒体",
        "answer": "D"
    },
    {
        "year": 1989,
        "question": "下列哪一种属于特异性免疫（）",
        "A": "淋巴结对病原菌的过滤",
        "B": "皮肤对痢疾病原菌的屏障作用",
        "C": "患过天花的人对天花病毒具不感染性",
        "D": "人体唾液中的溶菌酶使大肠杆菌死亡",
        "answer": "C"
    },
    {
        "year": 1990,
        "question": "毛细血管的特点之一是（）",
        "A": "管内只流动着含氧的血",
        "B": "管壁由一层扁平上皮细胞构成",
        "C": "血管的起始部位与最小的静脉相连",
        "D": "管内血流最快",
        "answer": "B"
    },
    {
        "year": 1991,
        "question": "蛙原肠腔的形成主要是通过（）",
        "A": "动物极细胞的外包和植物极细胞的内陷",
        "B": "动物极细胞和植物极细胞的外包",
        "C": "动物极细胞的内陷和植物极细胞的外包",
        "D": "动物极细胞和植物极细胞的内陷",
        "answer": "A"
    },
    {
        "year": 1992,
        "question": "人体内产生自细胞的器官,除了红骨髓之外，还有（）",
        "A": "淋巴结和肝脏",
        "B": "脾和扁桃体",
        "C": "黄骨髓和脾",
        "D": "扁桃体和肝脏",
        "answer": "B"
    },
    {
        "year": 1993,
        "question": "线粒体、叶绿体和内质网都具有（）",
        "A": "基粒",
        "B": "基质",
        "C": "膜结构",
        "D": "少量DNA",
        "answer": "C"
    },
    {
        "year": 1994,
        "question": "在臀部的外上部进行肌肉注射这是因为该处（）",
        "A": "肌肉发达",
        "B": "皮下组织较厚",
        "C": "血管较少",
        "D": "没有大的神经和血管",
        "answer": "D"
    },
    {
        "year": 1995,
        "question": "构成细胞内生命物质的主要有机成分是（）",
        "A": "蛋白质和核酸",
        "B": "水和蛋白质",
        "C": "蛋白质和脂类",
        "D": "水和核酸",
        "answer": "C"
    },
    {
        "year": 1996,
        "question": "由DNA分子蕴藏的信息所支配合成的RNA在完全水解后,得到的化学物质是（）",
        "A": "氨基酸、葡萄糖、碱基",
        "B": "氨基酸、核苷酸、葡萄糖",
        "C": "核糖、碱基、磷酸",
        "D": "脱氧核糖、碱基、磷酸",
        "answer": "C"
    },
    {
        "year": 1997,
        "question": "下列细胞中依靠渗透吸水的是（）",
        "A": "根生长点细胞",
        "B": "茎形成层细胞",
        "C": "失水的叶肉细胞",
        "D": "干燥种子的细胞",
        "answer": "C"
    },
    {
        "year": 1998,
        "question": "下列四组生物中，细胞结构最相似的是（）",
        "A": "变形虫、水绵、香菇",
        "B": "烟草、草履虫、大肠杆菌",
        "C": "小麦、番茄、大豆",
        "D": "酵母菌、灵芝、豌豆",
        "answer": "C"
    },
    {
        "year": 1999,
        "question": "动物细胞有丝分裂区别于植物细胞有丝分裂的特点是（）",
        "A": "核膜、核仁消失",
        "B": "形成纺锺体",
        "C": "中心粒周围发出星射线",
        "D": "着丝点分",
        "answer": "D"
    },
    {
        "year": 2000,
        "question": "在我国西部大开发的战略中，“保护天然林”和“退耕还林（草）”是两项重要内容，采取这两项措施的首要目标是（）",
        "A": "开展生态旅游",
        "B": "发展畜牧业",
        "C": "增加木材产量",
        "D": "改善生态环境",
        "answer": "D"
    },
    {
        "year": 2001,
        "question": "人体发生花粉等过敏反应时，毛细血管壁的通透性增加，血浆蛋白渗出，会造成局部（）",
        "A": "血浆量增加",
        "B": "组织液减少",
        "C": "组织液增加",
        "D": "淋巴减少",
        "answer": "B"
    },
    {
        "year": 2002,
        "question": "下列关于细胞周期的叙述，正确的是（）",
        "A": "成熟的生殖细胞产生后立即进入下一个细胞周期",
        "B": "机体内所有的体细胞处于细胞周期中",
        "C": "抑制DNA的合成，细胞将停留在分裂期",
        "D": "细胞分裂间期为细胞分裂期提供物质基础",
        "answer": "D"
    },
    {
        "year": 2003,
        "question": "下列关于细胞周期的叙述，正确的是（）",
        "A": "成熟的生殖细胞产生后立即进入下一个细胞周期",
        "B": "机体内所有的体细胞处于细胞周期中",
        "C": "抑制DNA的合成，细胞将停留在分裂期",
        "D": "细胞分裂间期为细胞分裂期提供物质基础",
        "answer": "D"
    },
    {
        "year": 2004,
        "question": "植物从土壤中吸收的氮元素，可以用来合成下列哪种物质()",
        "A": "葡萄糖",
        "B": "淀粉",
        "C": "脂肪",
        "D": "蛋白质",
        "answer": "D"
    },
    {
        "year": 2005,
        "question": "人体神经细胞与肝细胞的形态结构和功能不同，其根本原因是这两种、细胞的（）",
        "A": "DNA碱基排列顺序不同",
        "B": "核糖体不同",
        "C": "转运RNA不同",
        "D": "信使RNA不同",
        "answer": "D"
    },
    {
        "year": 2006,
        "question": "人的神经系统中，有些神经细胞既能传导兴奋，又能合成与分泌激素。这些细胞位于（）",
        "A": "大脑皮层",
        "B": "垂体",
        "C": "下丘脑",
        "D": "脊髓",
        "answer": "C"
    },
    {
        "year": 2007,
        "question": "下列有关种群增长的S型曲线的叙述，错误的是（）",
        "A": "通常自然界中的种群增曲线最终呈S型",
        "B": "达到K值时种群增长率为零",
        "C": "种群增长受自身密度的影响",
        "D": "种群的增长速度逐步降低",
        "answer": "D"
    },
    {
        "year": 2008,
        "question": "为了验证胰岛素具有降低血糖含量的作用，在设计实验方案时，如果以正常小鼠每次注射药物前后小鼠症状的变化为观察指标，则下列对实验组小鼠注射药物的顺序正确的是（）",
        "A": "先注射胰岛素溶液，后注射葡萄糖溶液",
        "B": "先注射胰岛素溶液，再注射胰高血糖素溶液",
        "C": "先注射胰岛素溶液，后注射生理盐水",
        "D": "先注射生理盐水，后注射胰岛素溶液",
        "answer": "A"
    },
    {
        "year": 2009,
        "question": "下列关于人类遗传病的叙述，错误的是（）",
        "A": "单基因突变可以导致遗传病",
        "B": "染色体结构的改变可以导致遗传病",
        "C": "近亲婚配可增加隐性遗传病的发病风险",
        "D": "环境因素对多基因遗传病的发病无影响",
        "answer": "D"
    },
    {
        "year": 2010,
        "question": "下列过程中，不直接依赖细胞膜的流动性就能完成的是（）",
        "A": "植物体细胞杂交中原生质体融合",
        "B": "mRNA与游离核糖体的结合",
        "C": "胰岛B细胞分泌胰岛素",
        "D": "吞噬细胞对抗原的摄取",
        "answer": "B"
    },
    {
        "year": 2011,
        "question": "将人的红细胞放入4℃蒸馏水中，一段时间后红细胞破裂，主要原因是（）",
        "A": "红细胞具有水溶性",
        "B": "红细胞的液泡体积增大",
        "C": "蒸馏水大量进入红细胞",
        "D": "低温时红细胞膜流动性增大",
        "answer": "C"
    },
    {
        "year": 2012,
        "question": "同一物种的两类细胞各产生一种分泌蛋白，组成这两种蛋白质的各种氨基酸含量相同，但排列顺序不同，其原因是参与这两种蛋白质合成的（）",
        "A": "tRNA种类不同",
        "B": "mRNA碱基序列不同",
        "C": "核糖体成分不同",
        "D": "同一密码子所决定的氨基酸不同",
        "answer": "B"
    },
    {
        "year": 2013,
        "question": "关于蛋白质生物合成的叙述，正确的是（）",
        "A": "一种tRNA可以携带多种氨基酸",
        "B": "DNA聚合酶是在细胞核中合成的",
        "C": "反密码子是位于mRNA上相邻的三个碱基",
        "D": "线粒体中的DNA能控制某些蛋白质的合成",
        "answer": "D"
    },
    {
        "year": 2014,
        "question": "下列植物细胞中，适合观察细胞有丝分裂的是（  ）",
        "A": "蚕豆叶肉细胞",
        "B": "洋葱鳞片叶表皮细胞",
        "C": "蚕豆根尖分生区细胞",
        "D": "洋葱根尖伸长区细胞",
        "answer": "C"
    },
    {
        "year": 2015,
        "question": "下列叙述，错误的是（）",
        "A": "DNA和ATP中所含元素的种类相同",
        "B": "一个tRNA分子中只有一个反密码子",
        "C": "T2噬菌体的核酸由脱氧核苷酸组成",
        "D": "控制细菌性状的基因位于拟核和线粒体DNA上",
        "answer": "C"
    },
    {
        "year": 2016,
        "question": "下列与细胞相关的叙述，正确的是（）",
        "A": "核糖体、溶酶体都是具有膜结构的细胞器",
        "B": "酵母菌的细胞核内含有DNA和RNA两类核酸",
        "C": "蓝藻细胞的能量来源于其线粒体有氧呼吸过程",
        "D": "在叶绿体中可进行CO2的固定但不能合成ATP",
        "answer": "B"
    },
    {
        "year": 2017,
        "question": "细胞间信息交流的方式有多种。在哺乳动物卵巢细胞分泌的雌激素作用于乳腺细胞的过程中，以及精子进入卵细胞的过程中，细胞间信息交流的实现分别依赖于（）",
        "A": "血液运输，突触传递",
        "B": "淋巴运输，突触传递",
        "C": "淋巴运输，胞间连丝传递",
        "D": "血液运输，细胞间直接接触",
        "answer": "D"
    },
    {
        "year": 2018,
        "question": "高等植物细胞中，下列过程只发生在生物膜上的是（  ）",
        "A": "光合作用中的光反应",
        "B": "光合作用中CO2的固定",
        "C": "葡萄糖分解产生丙酮酸",
        "D": "以DNA为模板合成RNA",
        "answer": "A"
    },
    {
        "year": 2019,
        "question": "若要观察植物细胞有丝分裂中期的染色体。适宜的材料和染液组合是（    ）",
        "A": "大蒜根尖细胞，龙胆紫溶液",
        "B": "玉米根尖细胞，台盼蓝染液",
        "C": "菠菜叶肉细胞，碘液",
        "D": "番茄果肉细胞，吡罗红染色剂",
        "answer": "A"
    },
    {
        "year": 2020,
        "question": "下列关于胰蛋白酶和胰岛素的叙述，正确的是（）",
        "A": "都可通过体液运输到全身",
        "B": "都在细胞内发挥作用",
        "C": "发挥作用后都立即被灭活",
        "D": "都能在常温下与双缩脲试剂发生作用，产生紫色反应",
        "answer": "D"
    }
]